import { render } from "./org-structure-view-ltv.vue?vue&type=template&id=2a3a0906"
import script from "./org-structure-view-ltv.vue?vue&type=script&setup=true&lang=js"
export * from "./org-structure-view-ltv.vue?vue&type=script&setup=true&lang=js"

import "./org-structure-view-ltv.vue?vue&type=style&index=0&id=2a3a0906&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/nsi/components/forms/org-structure-form/org-structure-view-ltv.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a3a0906"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a3a0906', __exports__)) {
    api.reload('2a3a0906', __exports__)
  }
  
  module.hot.accept("./org-structure-view-ltv.vue?vue&type=template&id=2a3a0906", () => {
    api.rerender('2a3a0906', render)
  })

}


export default __exports__